import { Flex } from '@servicetitan/anvil2';
import { Agreement } from './Agreement';
import { ConsentFields } from './ConsentFields';

interface ContainerProps {
    hasCoApplicant: boolean;
}

export const Container = (props: ContainerProps) => {
    return (
        <Flex
            direction="column"
            gap="4"
            alignSelf="center"
            style={{
                marginTop: '45px',
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: '845px',
            }}
        >
            <Agreement />
            <ConsentFields hasCoApplicant={props.hasCoApplicant} />
        </Flex>
    );
};
